import React from "react";
import { connect } from "react-redux";
import {
  Transition,
  Container,
  Header,
  Segment,
  Button
} from "semantic-ui-react";
import TablaIncidencias from "./listadoIncidencias/TablaIncidencias";
import { incidenciasOps } from "../../ducks/incidencias";

class ListadoAvisos extends React.Component {
  state = {
    datos: this.props.incidencias,
    visible: false
  };

  componentDidMount() {
    this.props.obtenerIncidenciasTodos();
    this.setState(state => ({ visible: true }));
  }

  componentWillUnmount() {
    this.props.resetIncidencias();
    this.props.detachIncidenciasTodos();
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    return {
      datos: nextProps.incidencias
    };
  }

  cerrarIncidencia = incidencia =>
    this.props.cerrarIncidencia({ incidencia, user: this.props.user });

  guardarIncidencia = (incidencia, texto) => {
    const { user } = this.props;
    const alumno = {
      id: incidencia.idAlumno,
      nombre: incidencia.nombreAlumno,
      apellido1: incidencia.apellidosAlumno,
      apellido2: ""
    };

    this.props.guardarIncidencia({ alumno, id: incidencia.id, texto, user });
  };

  handleVolver = () => this.props.history.goBack();

  render() {
    return (
      <Transition.Group animation="scale" duration={250}>
        {this.state.visible && (
          <Container fluid textAlign="center">
            <Segment>
              <Button
                content="Cerrar"
                floated="right"
                color="pink"
                icon="cancel"
                onClick={this.handleVolver}
              />
              <Header>Listado de Incidencias</Header>
            </Segment>
            <TablaIncidencias
              datos={this.state.datos}
              cerrarIncidencia={this.cerrarIncidencia}
              guardarIncidencia={this.guardarIncidencia}
            />
          </Container>
        )}
      </Transition.Group>
    );
  }
}

const toProps = state => ({
  incidencias: state.incidencias.incidencias,
  user: state.session.user
});

const actions = {
  resetIncidencias: incidenciasOps.resetIncidencias,
  obtenerIncidenciasTodos: incidenciasOps.obtenerIncidenciasTodos,
  detachIncidenciasTodos: incidenciasOps.detachIncidenciasTodos,
  cerrarIncidencia: incidenciasOps.cerrarIncidencia,
  guardarIncidencia: incidenciasOps.guardarIncidencia
};

export default connect(toProps, actions)(ListadoAvisos);



// WEBPACK FOOTER //
// ./src/pages/listados/ListadoIncidencias.jsx